import { X } from "lucide-react";
import { createPortal } from "react-dom";

import { InvoiceViewer } from "@/components/shared/file-viewers/invoice-viewer";
import { Button } from "@/components/ui/button";

type InvoicePreviewPortalProps = {
  invoiceId: string;
  isOpen: boolean;
  onClose: () => void;
};

export const InvoicePreviewPortal = ({
  invoiceId,
  isOpen,
  onClose,
}: InvoicePreviewPortalProps) => {
  if (!isOpen) return null;

  const portalTarget = document.getElementById("transactions-table");
  if (!portalTarget) return null;

  return createPortal(
    <div className="absolute top-0 right-0 bottom-[56px] h-[90%] w-3/4 z-50">
      <Button
        variant="outline"
        size="icon"
        className="absolute top-2 right-2 z-10 h-8 w-8 bg-background"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        <X className="h-4 w-4" />
      </Button>
      <InvoiceViewer invoiceId={invoiceId} />
    </div>,
    portalTarget,
  );
};
